import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';

import { DbTransform } from '../../../_helpers/db.transform';

import * as fromSortableColumn from '../../../sortableColumn/sortableColumn.function';

import { Globals } from '../../../_globals/globals';

@Component({
  selector: 'app-opti',
  templateUrl: './opti-list.component.html'
})

export class OptiListComponent implements OnInit, OnChanges {

  dbt: DbTransform;

  title: string;
  subtitle: string;

  deleteModal: boolean;
  compactModal: boolean;
  compactLotInput: string;

  searchOptiForm: FormGroup;
  itemsPerPage: number;
  currentPage: number;
  
  fromDate: Date;
  toDate: Date;

  sub: any;
  // paramNum: number;
  paramRefresh: string;

  setTimeout_aux: number;
  
  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  // Id del usuario actual logueado.
  current_user_id: number;
  current_group_id: number;
  current_username: string;
  current_enviroment: string;
  isManufacturer: boolean;
  
  button_virtual_pressed: boolean;
  compact_mode: string;

  @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;

  @Input() optiList: OptiData[];
  @Input() compactList: any;
  @Input() retalList: OptiPiece[];
  @Input() currentOpti: OptiData;
  @Input() filterFields: any[];
  @Output() searchOpti = new EventEmitter<any[]>();
  @Output() selectOpti: any = new EventEmitter<OptiData>();
  @Output() deleteOpti = new EventEmitter<OptiData>();
  @Output() updateRetalList: any = new EventEmitter<{opti_id: number}>();
  @Output() chargeOpti: any = new EventEmitter<{opti_id: number}>();
  @Output() compactOpti = new EventEmitter<any>();
  @Output() printCompactOpti = new EventEmitter<any>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();
  @Output() changingLoading = new EventEmitter<boolean>();
  @Output() changingLoading2 = new EventEmitter<boolean>();
  
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private globals: Globals
  ) {}

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      // this.paramNum = +params['num']; // Importante el '+' para obtener números
      this.paramRefresh = params['rf'];
    });

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);

    this.setTimeout_aux = 3000;

    this.title = 'Optimizaciones';
    this.subtitle = 'Listado';

    this.deleteModal = false;
    this.compactModal = false;
    this.compactLotInput = '';

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_group_id = Number(localStorage.getItem('group_id'));
    this.current_username = localStorage.getItem('username');
    this.current_enviroment = localStorage.getItem('enviroment');
    this.isManufacturer = localStorage.getItem('permissions') === 'Manufacturer';

    if (this.current_username !== null && this.current_username !== undefined) {
      this.current_username = this.current_username.split('@')[0];
    }

    console.log('->->< Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    console.log('--> -> FilterFields:');
    console.log(this.filterFields);
    
    // Por defecto la fecha de inicio para la búsqueda será de 15 días atrás.
    let subtract_days = 15;
    
    // Declaración de variables para el control de rango de fechas.
    this.fromDate = new Date();

    // NOTA: Colocamos la fecha inicial de búsqueda unos cuantos días atrás
    // dependiendo del perfil del usuario que esté logueado.
    this.fromDate.setDate(this.fromDate.getDate() - subtract_days);

    this.toDate = new Date();

    // this.toDate.setMinutes(this.toDate.getMinutes() + (13 * 60));

    if (this.filterFields['f_date'] === undefined || this.filterFields['f_date'] === null) {
      this.filterFields['f_date'] = this.fromDate;
    }

    if (this.filterFields['f_date2'] === undefined || this.filterFields['f_date2'] === null) {
      this.filterFields['f_date2'] = this.toDate;
    }

    this.filterFields['f_date'] = this.toDateInputValue(this.filterFields['f_date']);
    this.filterFields['f_date2'] = this.toDateInputValue(this.filterFields['f_date2']);

    this.searchOptiForm = this.formBuilder.group({
      filterField_0: this.filterFields['filterField_0'],
      filterField_1: this.filterFields['filterField_1'],
      filterField_2: this.filterFields['filterField_2'],
      filterField_3: this.filterFields['filterField_3'],
      opti_id: this.filterFields['opti_id'],
      opti_lot: this.filterFields['opti_lot'],
      opti_mat: this.filterFields['opti_mat'],
      opti_note: this.filterFields['opti_note'],
      groupId: this.current_group_id,
      type: 0,
      f_date: this.filterFields['f_date'],
      f_date2: this.filterFields['f_date2']
    });
    
    // El botón de compactación no ha sido pulsado.
    this.button_virtual_pressed = false;
    this.compact_mode = 'hybrid_family';
    this.itemsPerPage = 12;
    this.currentPage = 1;

    // Cargamos inicialmente la lista de inventario si el parámetro de refresco lo indica.
    if (this.paramRefresh === 'true') {
      this.buttonGetOptiList();
    }

    // Colocamos inicialmente el foco en el botón de búsqueda.
    this.searchButton.nativeElement.focus();

  } // End function OnInit

  ngOnChanges(changes: SimpleChanges) {

    console.log('->-> Entrando en ngOnChanges: ');
    // console.log(changes);

    if (changes.optiList !== undefined) {
      const list = this.optiList ? this.optiList : [];
      const totalPages = Math.max(1, Math.ceil(list.length / this.itemsPerPage));
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }
      if (this.currentPage < 1) {
        this.currentPage = 1;
      }
    }
    
    if (changes.compactList !== undefined) {
		
		console.log('--> ngOnChanges changes.compactList.currentValue:');
      	console.log(changes.compactList.currentValue);
      	
      	if (changes.compactList.currentValue && 
      		changes.compactList.currentValue.order_opti &&
      		changes.compactList.currentValue.total_virtual &&
          changes.compactList.currentValue.order_opti.length > 0 &&
          changes.compactList.currentValue.total_virtual.length > 0 &&
      		this.button_virtual_pressed) {
				
			// NOTA: Es neceasario hacer uso de la variable "button_virtual_pressed"
			// para que no se imprima el pdf cuando cambiemos de sección en la aplicación.
			// Con este método nos aseguramos que sólo se imprima cuando el usuario
			// haya pulsado antes el botón correspondiente de "Compactar Pilas".
			
			console.log('--> Detectadas piezas de las optimizaciones para compactar.');
			
			// Llamamos a la función que imprime el pdf con pilas
			// compactadas pasándole toda la información necesaria.
			this.printCompactPile(changes.compactList.currentValue);
		} else if (this.button_virtual_pressed) {
      this.button_virtual_pressed = false;
      this.alertInfo = 'No se han encontrado optimizaciones para el lote indicado.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
		}
      
	} // End changes.compactList.

  } // End function ngOnChanges

  private toDateInputValue(value: any): string {

    if (value === undefined || value === null || value === '') {
      return '';
    }

    const parsedDate = (value instanceof Date) ? value : new Date(value);

    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  // convenience getter for easy access to form fields
  get f() { return this.searchOptiForm.controls; }

  // ---------------------------------------
  //          Funciones Asíncronas
  // ---------------------------------------

  async emitSelectOpti(optiIn) {

    console.log('->> Entrando en emitSelectOpti...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitSelectOpti:');
      const add  = this.selectOpti.emit(optiIn);
      console.log('->> Final Promesa de emitSelectOpti:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitSelectOpti:');
      console.log(response);
    }).catch((error) => {
      console.log('->> Error en emitSelectOpti:');
      console.log(error);
    });
    // return setTimeout(() => {this.writeText('Terminando emitSelectOpti...')}, this.setTimeout_aux);

    // return await this.emitSelectOpti.emit(inventoryIn);

  } // End function emitSelectOpti
  
  async emitUpdateRetalList(optiIn, groupConsultIn) {

    console.log('->> Entrando en emitUpdateRetalList...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitUpdateRetalList:');
      const add = this.updateRetalList.emit({opti_id: optiIn['id']});
      console.log('->> Final Promesa de emitUpdateRetalList:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitUpdateLagerList:');
      console.log(response);
    }).catch((error) => {
      console.log('->> Error en emitUpdateLagerList:');
      console.log(error);
    });

  } // End function emitUpdateRetalList
  
  async emitChargeOpti(optiIn, groupConsultIn) {

    console.log('->> Entrando en emitChargeOpti...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitChargeOpti:');
      const add = this.chargeOpti.emit({opti_id: optiIn['id']});
      console.log('->> Final Promesa de emitChargeOpti:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitChargeOpti:');
      console.log(response);
    }).catch((error) => {
      console.log('->> Error en emitChargeOpti:');
      console.log(error);
    });

  } // End function emitChargeOpti

  // NOTA: función que coge los parámetros del formulario y los "emite" fuera.
  async buttonGetOptiList() {
    console.log('-->--> Pulsado botón Buscar optimización. Formulario:');

    console.log(this.searchOptiForm.value);

    this.searchOpti.emit(this.searchOptiForm.value);

  } // End function buttonGetOptiList
  
  // Función que se ejecuta cuando se pulsa el botón "Consumir" para pasar a la sección de "OptiConsume".
  async buttonPileCompact(lotIn?: string) {

    if (this.isManufacturer) {
      return;
    }
	
	console.log('-> -> buttonPileCompact:  ');
	console.log(this.optiList);
	
	let lot_ok = true;
	
	let lot = null;
	/*
	if (this.optiList && this.optiList.length > 0) {
		
		lot =  this.optiList[0].od_lots_number;
		
		this.optiList.forEach(opti =>  {
			
			if (opti.od_lots_number !== lot)
				lot_ok = false;
		});
	} // */
	
	let list_aux = [];
	
	let lot_aux = (lotIn !== undefined && lotIn !== null) ? lotIn : this.searchOptiForm.controls.opti_lot.value;
  lot_aux = (lot_aux ? lot_aux.toString() : '').trim();

  if (lot_aux.includes(',')) {
    this.alertInfo = 'En esta pantalla solo se permite compactar un único lote por ejecución.';
    this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    return;
  }
	
	let lot_list = lot_aux !== '' ? lot_aux.split(',') : [];
	
	lot_list.forEach(lot =>  {
		list_aux.push(lot.trim());
	});
	
	console.log('-> Lista de lotes en campo "Lotes":');
	console.log(list_aux);
	
	if (list_aux.length <= 0) lot_ok = false;
	
	this.optiList.forEach(opti =>  {
			
		if (!list_aux.includes(opti.od_lots_number)) {
			list_aux.push(opti.od_lots_number);
		}
	});
	
	console.log('-> Lista de lotes para compactar:');
	console.log(list_aux)
	
	// Si todas las optimizacione listadas tienen el mismo número de lote
	// entonces se puede proceder a compactar las pilas de todas juntas.
	if (lot_ok) {
		
		console.log('-> Todas las optimizaciones tienen un lote incluido en el campo "Lotes": ' + lot_aux);
		
		// Primero hay que obtener la información detallada
		// de todas las optimizaciones listadas.
		this.compactOpti.emit({
      opti_lot: lot_aux,
      exact_lot: true,
      compact_mode: this.compact_mode === 'hybrid_family_plus'
        ? 'hybrid_family_plus'
        : (this.compact_mode === 'hybrid_family' ? 'hybrid_family' : 'classic')
    });
		
		// Indicamos que el botón de compactación ha sido pulsado
		// para que cuando se reciba la lista de pilas se lance
		// la función que imprime la información pedida.
		this.button_virtual_pressed = true;
		
	} else {
		console.log('-> Hay que indicar al menos un número de lote en el campo "Lote" y luego pulsar el botón "Buscar" antes de "Compactar Pilas".');
		
		this.alertInfo = 'Para poder compactar las pilas hay que indicar al menos un número de lote en el campo "Lote" (o varios separados por comas) y luego pulsar el botón "Buscar". <br>';
		
		this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	}
    
  } // End buttonPileCompact 

  showCompactModal(valueIn: boolean) {
    if (this.isManufacturer) {
      this.compactModal = false;
      return;
    }
    this.compactModal = valueIn;

    if (!valueIn) {
      return;
    }

    let defaultLot = this.searchOptiForm && this.searchOptiForm.controls && this.searchOptiForm.controls.opti_lot
      ? this.searchOptiForm.controls.opti_lot.value
      : '';
    defaultLot = defaultLot ? defaultLot.toString().trim() : '';

    if (defaultLot === '' && this.optiList && this.optiList.length > 0 && this.optiList[0] && this.optiList[0].od_lots_number) {
      defaultLot = this.optiList[0].od_lots_number.toString();
    }

    this.compactLotInput = defaultLot;
  }

  confirmCompactModal() {
    if (this.isManufacturer) {
      this.compactModal = false;
      return;
    }
    const lotValue = this.compactLotInput ? this.compactLotInput.toString().trim() : '';

    if (lotValue === '') {
      this.alertInfo = 'Indica al menos un número de lote para compactar.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    if (lotValue.includes(',')) {
      this.alertInfo = 'En esta pantalla solo se permite un número de lote.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    this.searchOptiForm.controls.opti_lot.setValue(lotValue);
    this.compactModal = false;
    this.buttonPileCompact(lotValue);
  }

  // Función que se ejecuta cuando se pulsa el botón "Consumir" para pasar a la sección de "OptiConsume".
  async buttonSetCurrentOpti(opti: OptiData | null) {
    console.log('-> -> buttonSetCurrentOpti seleccionada optimización:');
    console.log(opti);

    // tslint:disable-next-line:only-arrow-functions
    const dataEmitSelectOpti = await this.emitSelectOpti(opti).then(async function(data) {

      console.log('->> emitSelectOpti data => ');
      console.log(data);

      return data;
    });

    console.log('-> -> Cargados datos de la optimización seleccionada para la siguiente sección desde emitSelectOpti:');
    console.log(dataEmitSelectOpti);

    const dataEmitUpdateRetalList = await this.emitUpdateRetalList(opti, true).then(async function(data) {

      console.log('->> dataEmitUpdateRetalList data => ');
      console.log(data);

      return data;
    });

    console.log('-> -> Cargados datos preparatorios para la siguiente sección desde dataEmitUpdateRetalList:');
    console.log(dataEmitUpdateRetalList);

    // Una vez se tengan los datos actualizados para poder cargar bien
    // la siguiente sección, se hace el redireccionamiento hacia la misama.
    setTimeout(() => {this.router.navigate(['/opti_edit']); }, this.setTimeout_aux);

  } // End function buttonSetCurrentOpti
  
  // Función que se ejecuta cuando se pulsa el botón "Consumir" para pasar a la sección de "OptiConsume".
  async buttonChargeOpti(opti: OptiData | null) {
    console.log('-> -> buttonChargeOpti seleccionada optimización:');
    console.log(opti);

    // tslint:disable-next-line:only-arrow-functions
    const dataEmitSelectOpti = await this.emitSelectOpti(opti).then(async function(data) {

      console.log('->> buttonChargeOpti emitSelectOpti data => ');
      console.log(data);

      return data;
    });

    console.log('-> -> Cargados datos de la optimización seleccionada para tener ya su información;');
    console.log(dataEmitSelectOpti);

    const dataEmitUpdateRetalList = await this.emitChargeOpti(opti, true).then(async function(data) {

      console.log('->> buttonChargeOpti data => ');
      console.log(data);

      return data;
    });

    console.log('-> -> Cargados datos preparatorios para la siguiente sección desde buttonChargeOpti:');
    console.log(dataEmitUpdateRetalList);

    // Una vez se tengan los datos actualizados para poder cargar bien
    // la siguiente sección, se hace el redireccionamiento hacia la misama.
    setTimeout(() => {this.router.navigate(['/file-list', 'charge']); }, this.setTimeout_aux);

  } // End function buttonChargeOpti

  // ---------------------------------------
  //        FIN Funciones Asíncronas
  // ---------------------------------------
  
  async buttonDeleteOpti(item: any, indexIn: number) {
    console.log('---> Entrando en buttonDeleteOpti: ' + indexIn);
    
    const dataEmitSelectOpti = await this.emitSelectOpti(item).then(async function(data) {

      console.log('->> buttonDeleteOpti emitSelectOpti => ');
      console.log(data);

      return data;
    });

    this.showDeleteModal(true);
    
  } // End function buttonDeleteOpti
  
  showDeleteModal(value: boolean) {
    this.deleteModal = value;

  } // End function showDeleteModal
  
  confirmDeleteEasel() {
	console.log('->> confirmDeleteEasel => ');
	console.log(this.currentOpti);
	
    this.deleteOpti.emit(this.currentOpti);
    this.showDeleteModal(false);
  }

  // Función que filtra de un array los valores que no sean superiores a cero de un campo dado.
  filterZeroItems(listIn: [], fieldIn: string) {
    return listIn.filter(x => x[fieldIn] > 0);
  } // End function filterZeroItems

  // --------- Detectar tecla presionada
  onKeydown(event: any) {
    // console.log('Presionada tecla...');
    // console.log(event);
    if (event.key === 'Enter') {
      // console.log('--> Tecla ENTER.');

      this.buttonGetOptiList();
    }
  } // End function onKeydown

  // Función que ordena el listado de elementos.
  onSorted(event: any) {
    console.log('--> onSorted Tabla directiva lanzada:');
    console.log(event);

    // console.log(' -> Columna a ordenar: ' + event.sortColumn);
    // console.log(' -> Dirección orden: ' + event.sortDirection);
    // console.log(' -> Es número: ' + event.isNumeric);

    // Si hubiese que realizar alguna acción específica para la columna seleccionada.
    // switch (event.sortColumn) {
    //   case 'mat_desc':
    //     break;

    //   case 'lagm_platz':
    //     break;
    // }

    // Se lanza la función de ordenación del array de inventario.
    // Modifica directamente el array pasado como primer parámetro.
    // NOTA: el nombre de la columna, al ser para ORACLE, tendrá que estar en mayúsculas.
    this.optiList = fromSortableColumn.sortByColumn(
    this.optiList, this.dbt.t(event.sortColumn), event.sortDirection, event.isNumeric);

    console.log('--> Array después de la ordenación:');
    console.log(this.optiList);

  } // End function onSorted
  
  // Función que obtiene el primer elemento de un array JSON pasado como cadena.
  getProductId(value) {
	return JSON.parse(value)[0];
  }

  getOptimizationTimeLabel(itemIn: any): string {
    if (!itemIn || itemIn['od_optimization_time'] === undefined || itemIn['od_optimization_time'] === null) {
      return 'N/D';
    }

    const totalSeconds = Number(itemIn['od_optimization_time']);
    if (isNaN(totalSeconds) || totalSeconds <= 0) {
      return 'N/D';
    }

    const wholeSeconds = Math.floor(totalSeconds);
    const hours = Math.floor(wholeSeconds / 3600);
    const minutes = Math.floor((wholeSeconds % 3600) / 60);
    const seconds = wholeSeconds % 60;

    return this.pad2(hours) + ':' + this.pad2(minutes) + ':' + this.pad2(seconds);
  }

  getCncFamily(itemIn: any): string {
    if (!itemIn) {
      return '-';
    }

    const directField = itemIn['od_cnc'] ? itemIn['od_cnc'].toString().trim().toUpperCase() : '';
    if (directField !== '') {
      return directField;
    }

    const stateRaw = itemIn['od_state'] ? itemIn['od_state'].toString() : '';
    const stateObj = this.parseStateTokens(stateRaw);

    const directCnc = stateObj['CNC'] ? stateObj['CNC'].toString().trim().toUpperCase() : '';
    if (directCnc !== '') {
      return directCnc;
    }

    const tableName = stateObj['CUTTING_TABLE_NAME'] ? stateObj['CUTTING_TABLE_NAME'].toString().trim().toUpperCase() : '';
    if (tableName !== '') {
      if (tableName.indexOf('TEC') !== -1 || tableName.indexOf('TECNOMETAL') !== -1) return 'TEC';
      if (tableName.indexOf('BTR') !== -1 || tableName.indexOf('BOTTERO') !== -1) return 'BTR';
      if (tableName.indexOf('V40') !== -1 || tableName.indexOf('TUROMAS') !== -1) return 'V40';
      if (tableName.indexOf('LSW') !== -1 || tableName.indexOf('LISEC') !== -1) return 'LSW';
      if (tableName.indexOf('OTD') !== -1 || tableName.indexOf('INTERMAC') !== -1) return 'OTD';
      if (tableName.indexOf('ELO') !== -1 || tableName.indexOf('ELORGLASS') !== -1) return 'ELO';
    }

    // Fallback: snapshot de layout guardado en BD (form.export).
    const snapshotRaw = itemIn['od_layout_snapshot'];
    const snapshotObj = this.parseSnapshot(snapshotRaw);
    const exportCode = snapshotObj && snapshotObj.form && snapshotObj.form.export
      ? snapshotObj.form.export.toString().trim().toUpperCase()
      : '';
    if (exportCode !== '') {
      return exportCode;
    }

    // Último fallback por notas.
    const note = itemIn['od_notes'] ? itemIn['od_notes'].toString().toUpperCase() : '';
    if (note.indexOf('TEC') !== -1) return 'TEC';
    if (note.indexOf('BTR') !== -1) return 'BTR';
    if (note.indexOf('V40') !== -1) return 'V40';
    if (note.indexOf('LSW') !== -1) return 'LSW';
    if (note.indexOf('OTD') !== -1) return 'OTD';
    if (note.indexOf('ELO') !== -1) return 'ELO';

    return '-';
  }

  private parseSnapshot(rawIn: any): any {
    if (!rawIn) {
      return null;
    }
    if (typeof rawIn === 'object') {
      return rawIn;
    }
    if (typeof rawIn !== 'string') {
      return null;
    }
    const txt = rawIn.toString().trim();
    if (txt === '') {
      return null;
    }
    try {
      return JSON.parse(txt);
    } catch (e) {
      return null;
    }
  }

  private parseStateTokens(stateRawIn: string): any {
    const out = {};
    if (!stateRawIn) {
      return out;
    }

    const raw = stateRawIn.toString().trim();
    if (raw === '') {
      return out;
    }

    // Intento JSON (algunos históricos guardan estado serializado).
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        Object.keys(parsed).forEach(key => {
          if (!key) return;
          out[key.toString().trim().toUpperCase()] = parsed[key];
        });
      }
    } catch (e) {
      // no-op
    }

    const tokens = raw.split(/[;,]/);
    tokens.forEach((tokenIn: string) => {
      const token = tokenIn ? tokenIn.toString().trim() : '';
      if (token === '') {
        return;
      }
      const eq = token.indexOf('=');
      if (eq <= 0) {
        return;
      }
      const key = token.substring(0, eq).trim().toUpperCase();
      const value = token.substring(eq + 1).trim();
      out[key] = value;
    });

    return out;
  }

  pad2(valueIn: number): string {
    return valueIn.toString().padStart(2, '0');
  }

  getRowIndex(indexOnPageIn: number): number {
    return this.itemsPerPage * (this.currentPage - 1) + (indexOnPageIn + 1);
  }

  getStacksLabel(itemIn: any): string {
    if (!itemIn) {
      return '---';
    }

    const snapshotObj = this.parseSnapshot(itemIn['od_layout_snapshot']);
    const snapshotStacks = snapshotObj && snapshotObj.metrics && snapshotObj.metrics.total_area_c !== undefined
      ? Number(snapshotObj.metrics.total_area_c)
      : NaN;

    if (Number.isFinite(snapshotStacks) && snapshotStacks > 0) {
      return Math.round(snapshotStacks).toString();
    }

    const persistedStacks = Number(itemIn['od_total_easels']);
    if (Number.isFinite(persistedStacks) && persistedStacks > 0) {
      return Math.round(persistedStacks).toString();
    }

    return '---';
  }

  pageChanged(eventIn: any) {
    this.currentPage = eventIn;
  }
  
  // Función que manda los datos necesarios para imprimir el informe de la compactación.
  printCompactPile(compactPileIn) {
	
	console.log('--> printCompactPile:');
    console.log(compactPileIn);
    
    // NOTA: para usar la función de impresión en PDF.
    this.printCompactOpti.emit({
      compact_list_info: compactPileIn,
      action: 'PrintCompactPile',
      back: 'file-list'
    });
	
  } // End function printCompactPile.

} // End class MovementListComponent
